module.exports = __webpack_public_path__ + "static/img/1.f39b615.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/1.png
// module id = qKey
// module chunks = 0